import type { BudgetPeriod } from '@finapp/types';
import { apiUrl, fetchWithAuth } from '../config/api';

// Minimal wrapper around GET /api/v1/budgets/periods - just enough for useCommitments to
// resolve which budget period a new commitment should attach to. BudgetPage.tsx /
// CostpointBudgetEditPage.tsx call this same endpoint directly via raw fetch (predating this
// services/ convention); this wrapper exists so useCommitments's dependency is mockable in
// tests the same way forecastApi/commitmentsApi already are, rather than every test render
// of <Forecast /> making a real (failing) network call.
export const budgetPeriodsApi = {
  async listPeriods(): Promise<BudgetPeriod[]> {
    const response = await fetchWithAuth(apiUrl('budgets/periods'));
    return (await response.json()) as BudgetPeriod[];
  },
};
